import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';

import {
    HisSearchResultComponent, HisAuthService, HisUiService, HisNotificationService, HisConfirmationService,
    HisGlobalDataService, Notification, HisNavigationService, HisSearchService
} from 'hisng';

import { CONFIRMATION_PDIALOG_KEY } from 'app/fs/res/common/component/confirmation-dialogs/confirmation-dialog.component';
import { INFORMATION_PDIALOG_KEY } from 'app/fs/res/common/component/confirmation-dialogs/information-dialog.component';
import { NOTIFICATION } from 'app/fs/res/publication/model/constants';
import { PublicationService } from 'app/fs/res/publication/service/publication.service';
import { PublicationModuleOptions } from '../../../publication-module.options';
import { PublicationImportService } from '../../../service/publication-import.service';

@Component( {
    selector: 'res-publication-import-search-result',
    templateUrl: './publication-import-search-result.component.html'
} )
export class PublicationImportSearchResultComponent implements OnInit {

    public readonly moduleOptions = PublicationModuleOptions;

    @ViewChild( HisSearchResultComponent, { static: true } ) searchResultComponent: HisSearchResultComponent;
    public showBackButton = false;

    readonly SEARCH_CONFIG_PUBLICATION_IMPORTS = 'fs/res/searchPublicationImports.xml';
    search: any = { configFile: this.SEARCH_CONFIG_PUBLICATION_IMPORTS, groups: [] };

    constructor(
        public auth: HisAuthService,
        private route: ActivatedRoute,
        private confirmationService: HisConfirmationService,
        private notificationService: HisNotificationService,
        private publicationImportService: PublicationImportService,
        public publicationService: PublicationService, // not private because used in the template
        private globalDataService: HisGlobalDataService,
        private hisUiService: HisUiService,
        private navigationService: HisNavigationService,
        private router: Router,
        private searchService: HisSearchService
    ) { }

    ngOnInit() {
        this.publicationService.userProfileService.getValueforKey('importResultview').subscribe((value: string)=>{
            if(value==='Liste'){
                this.publicationService.switchListTable('importResultview', true);
            }
            else{
                this.publicationService.switchListTable('importResultview', false);
            }
        });

        this.route.queryParams.subscribe( (queryParams: Params) => {
            this.showBackButton = queryParams.showBackButton ? queryParams.showBackButton === 'true' : this.showBackButton;
        } );

        // gegebenenfalls Meldung ausgeben, die von der vorherigen Seite (z.B. Duplikatsseite) gesetzt wurde
        let notification = this.globalDataService.getData(NOTIFICATION) as Notification;
        if (notification) {
            this.notificationService.notify(notification);
            this.globalDataService.removeData(NOTIFICATION);
        }
    }

    /* delete selected publication from database */
    deleteRow( publicationRow: any ) {
        this.publicationService.canDeletePublication( publicationRow.get( 'Publication.id' ) ).subscribe( (canDelete: string) => {
            if ( canDelete === '' ) {
                this.confirm( 'fs.res.publication.confirmDeletePublication', publicationRow, canDelete );
            } else {
                this.confirm( canDelete, publicationRow, canDelete );
            }
        } );
    }

    page( event: { first: number; rows: number } ) {
        this.searchResultComponent.loadPage( event.first );
        this.searchResultComponent.onPage( event );
    }

    /**
     * confirmation service to load confirmation / information dialog
     *
     * @param msg dialog message
     * @param publicationRow publication (object) to delete
     * @param canDelete identifier publication can be deleted
     */
    private confirm( msg: string, publicationRow: any, canDelete: string ) {
        this.confirmationService.confirm( {
            key: canDelete === '' ? CONFIRMATION_PDIALOG_KEY : INFORMATION_PDIALOG_KEY,
            message: canDelete === '' ? this.hisUiService.translate( msg, publicationRow.get( 'Publication.title' ) ) : canDelete,
            accept: () => {
                if ( canDelete === '' ) {
                    let publicationId = publicationRow.get( 'Publication.id' );
                    this.publicationService.deletePublication( publicationId ).subscribe( (deleteSuccess: number) => {
                        if ( deleteSuccess === 1 ) {
                            this.notificationService.deleteSuccessI18nRes();
                            this.searchResultComponent.reloadPageAfterDelete();
                        }
                    } );
                }
            }
        } );
    }

    getViewlinkQueryParams() {
        return {
            showBackButton: false,
            showSearchButton: false,
            prevPage: 'importCandidates'
        };
    }

    getEditlinkQueryParams() {
        return {
            showBackButton: false,
            showSearchButton: false,
            showDeleteButton: false,
            prevPage: 'importCandidates'
        };
    }

    /** Store current url in SessionStorage for back button on next page */
    onBeforeNavigate() {
        this.navigationService.setLastBackUrl(window.location.href);
    }

    selectAll() {
        this.publicationImportService.getPublicationIdsOfImportCandidates().subscribe(publicationIds => {
            this.searchResultComponent.selectedRows = this.searchResultComponent.rows.slice();

            this.searchResultComponent.selectedOptions = [];
            // eslint-disable-next-line @typescript-eslint/naming-convention
            publicationIds.forEach(id => this.searchResultComponent.selectedOptions.push({ id: id, 'Publication.id': id }) );
        });
    }

    deselectAll() {
        this.searchResultComponent.selectedRows = [];
        this.searchResultComponent.selectedOptions = [];
    }

    deleteSelectedRows() {
        const rows = this.searchResultComponent.selectedOptions;
        const numberOfRows = rows.length;
        if (numberOfRows > 0) {
            this.confirmationService.confirm( {
                key: CONFIRMATION_PDIALOG_KEY,
                message: this.hisUiService.translate( 'fs.res.publication.import.deletion.confirm', rows.length),
                accept: () => {
                    this.publicationService.deletePublications(rows.map(r => r.id)).subscribe((result: string[]) => {
                        this.notificationService.clear();
                        if (result?.length) {
                            this.notificationService.warnI18nRes('fs.res.publication.import.deletion.validationError', result.map(p => '<li>' + p + '</li>').join(''));
                        } else {
                            this.notificationService.success(this.hisUiService.translate('view.success.delete.number', numberOfRows), this.hisUiService.translate('fs.res.common.confirmation.delete'));
                        }
                        this.deselectAll();
                        this.searchResultComponent.reloadPageAfterDelete();
                    });
                }
            } );
        } else {
            this.notificationService.infoI18n('fs.res.publication.import.deletion.noRowsSelected');
        }
    }

    /** Zurück zur Hauptseite des Publikationsimports */
    back() {
        this.router.navigate( ['pub/import'] );
    }
}
